
import { Link } from 'themes/jumbo/@jumbo/shared';
import { NavbarItem } from 'themes/jumbo/@jumbo/types';
import UpgradeIcon from '@mui/icons-material/Upgrade';
import { NotificationsPopover } from 'themes/jumbo/app/_components/popovers/NotificationsPopover';
import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  SxProps,
  Theme,
  Button,
  Tooltip,
} from '@mui/material';
import { useJumboNavItemSx, useJumboNavbar } from '../../hooks';
import { Icon } from 'themes/jumbo/@jumbo/components/Icon';
import { makeStyles } from "tss-react/mui";
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { trackEvent } from 'components/Tracking';

type JumboNavItemProps = {
  item: NavbarItem | undefined;
  isNested: boolean;
};

const sideStyles = (miniAndClosed: boolean) => makeStyles()((theme: any) => ({
  menuItem: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    position: 'relative',
    color: 'inherit',
    textDecoration: 'none',
    padding: !miniAndClosed
        ? typeof theme.spacing === 'function'
          ? theme.spacing(1, 3.75)
          : 0
        : 0,
    justifyContent: 'center',
  },
  help: {
    position: "absolute",
    bottom: 50,
    width: '100%',
	'&:hover': {
      backgroundColor: 'transparent',
      '&::before': {
        display: 'none'
      }
    }
  },
  support: {
    position: "absolute",
    bottom: 10,
    width: '100%',
	'&:hover': {
      backgroundColor: 'transparent',
      '&::before': {
        display: 'none'
      }
    }
  },
  upgrade: {
    position: "absolute",
    bottom: 90,
    width: '100%',
    padding: '8px 30px',
    '& button': {
      width: '100%',
      backgroundColor: '#56678bff !important',
      boxShadow: 'none',
      '&:hover': {
        backgroundColor: '#27749eff',
        boxShadow: 'none',
      }
    },
    '&:hover': {
      backgroundColor: 'transparent',
      '&::before': {
        display: 'none'
      }
    }
  },

}));

function JumboNavItem({ item, isNested }: JumboNavItemProps) {

  const navSx: SxProps<Theme> = useJumboNavItemSx(item?.path ?? '');
  const { miniAndClosed } = useJumboNavbar();
  const ipn_name = useSelector((state: RootState) => state.auth.data.ipn_name);

  //TODO: this component depends on this useTranslations

  if (!item) return null;

  const { classes } = sideStyles(miniAndClosed)();
  const parts = item.path.split('/');
  const itemID: string = item.id || parts.pop() || parts.pop() || '';


  const openNewTab = (label:any) => {
    console.log(label)
  };

  const upgrade = (e:any) => {
    e.preventDefault()
	trackEvent("Menu", "MenuItem", "Upgrade")
    const url = "https://voxelspace.com/#pricing";
    console.log("Upgrade")
    window.open(url, '_blank');
  }


  return (
    <>
      	{ ipn_name === 'free' && itemID === 'help' && (
        <ListItemButton component={'li'} sx={{ ...navSx, backgroundColor: '56678bff !important' }} className={classes.upgrade} onClick={upgrade} >
            {
			   !miniAndClosed ? 
                
					<Button 
						onClick={upgrade} 
						color="primary"
						variant="contained" 
						size='small'
						startIcon={<UpgradeIcon fontSize="small"/>} 
					>
						Upgrade
					</Button>
				:
					<Tooltip title="Upgrade" placement="right" arrow>
						<ListItemIcon
							sx={{ minWidth: miniAndClosed ? 20 : 32, color: 'inherit' }}
						>

							<Icon name='upgrade' sx={{ fontSize: 20 }} />
						</ListItemIcon>
					</Tooltip>
			}
        </ListItemButton>
	 	 )}
      	<ListItemButton component={'li'} sx={{ ...navSx }} className={ item.id === "support" ? classes.support : item.id === "help" ? classes.help : "" }>
        {
            ['help', 'support'].includes(itemID) ?
            <a 
				style={{textDecoration:'none'}}
				className={classes.menuItem}
				id={`menu-${itemID}`}
				href={item.path} target="_blank" rel="noopener noreferrer"
				onClick={() => trackEvent("Menu", "MenuItem", item.label)}
				>
				{
				miniAndClosed ? 
					<Tooltip title={item.label} placement="right" arrow>
						<ListItemIcon
							sx={{ minWidth: miniAndClosed ? 20 : 32, color: 'inherit' }}
						>
							<Icon name={item.icon} sx={{ fontSize: 20 }} />
						</ListItemIcon>
					</Tooltip>
					:
					<>
					<ListItemIcon
						sx={{ minWidth: miniAndClosed ? 20 : 32, color: 'inherit' }}
					>
						<Icon name={item.icon} sx={{ fontSize: 20 }} />
					</ListItemIcon>
					<ListItemText
						primary={item.label}
						sx={{
							m: 0,
							'& .MuiTypography-root': {
								whiteSpace: 'nowrap',
								overflow: 'hidden',
								textOverflow: 'ellipsis',
							},
						}}
              		/>
					</>
				}
            </a>
          	:
          	<Link
				underline={'none'}
				to={item.path}
				{...(item.target ? { target: item.target} : {})}
				className={classes.menuItem}
				id={`menu-${itemID}`}
				onClick={() => trackEvent("Menu", "MenuItem", item.label)}
			>
				{
				miniAndClosed ?
					<Tooltip title={item.label} placement="right" arrow>
						<ListItemIcon
						sx={{ minWidth: miniAndClosed ? 20 : 32, color: 'inherit' }}
						>
						<Icon name={item.icon} sx={{ fontSize: 20 }} />
						</ListItemIcon>
					</Tooltip>
				:
					<>
					<ListItemIcon
						sx={{ minWidth: miniAndClosed ? 20 : 32, color: 'inherit' }}
						>
						<Icon name={item.icon} sx={{ fontSize: 20 }} />
					</ListItemIcon>
					<ListItemText
						primary={item.label}
						sx={{
						m: 0,
						'& .MuiTypography-root': {
							whiteSpace: 'nowrap',
							overflow: 'hidden',
							textOverflow: 'ellipsis',
						},
						}}
					/>
					</>
				}
				
				{
				item.label === 'Pending' 
				? 
					<NotificationsPopover category="pending" path={item.path} miniAndClosed={miniAndClosed} />
				:
				''
				}
				{
					item.label === 'Issues' 
				? 
					<NotificationsPopover category="issues" path={item.path} miniAndClosed={miniAndClosed} />
				:
				''
				}
			</Link>
  		}
      	</ListItemButton>
    </>
  );
}

export { JumboNavItem };
